(function () {
	const STORAGE_KEY = "cb_selected_city";
	let pendingDrawerId = null; // Armazena o ID do drawer que deve ser aberto após seleção da cidade
	let openedFromHeader = false; // Flag para indicar se o modal foi aberto pelo botão do header
	let openedByShowModal = false; // Flag para indicar se o modal foi aberto pela função showModal
	let openedAutomaticallyOnProductPage = false; // Flag para indicar se o modal foi aberto automaticamente na página de produto

	function getCity() {
		try {
			return localStorage.getItem(STORAGE_KEY);
		} catch (e) {
			return null;
		}
	}

	function setCity(city) {
		try {
			localStorage.setItem(STORAGE_KEY, city);
		} catch (e) {
			// ignore
		}
	}

	function updateSelectedCityButton() {
		const city = getCity();
		const buttons = document.querySelectorAll("[data-city-select]");

		buttons.forEach((button) => {
			const buttonCity = button.getAttribute("data-city-select");
			if (city && buttonCity === city) {
				button.classList.add("city-modal__button--selected");
			} else {
				button.classList.remove("city-modal__button--selected");
			}
		});
	}

	function showModal(fromHeader = false) {
		const modal = document.getElementById("city-modal");
		if (!modal) return;

		// Marca se foi aberto pelo header
		openedFromHeader = fromHeader;
		// Marca que foi aberto pela função showModal
		openedByShowModal = true;

		// Remove o estado de sucesso se existir
		modal.classList.remove("city-modal--success");

		// Atualiza o estado visual dos botões antes de abrir o modal
		updateSelectedCityButton();

		modal.classList.add("city-modal--active");
		modal.setAttribute("aria-hidden", "false");

		// Reseta a flag após um pequeno delay para permitir que o MutationObserver veja a mudança
		setTimeout(() => {
			openedByShowModal = false;
		}, 100);
	}

	function hideModal() {
		const modal = document.getElementById("city-modal");
		if (!modal) return;

		modal.classList.remove("city-modal--active");
		modal.classList.remove("city-modal--success");
		modal.setAttribute("aria-hidden", "true");
	}

	function showSuccessMessage(city) {
		const modal = document.getElementById("city-modal");
		if (!modal) return;

		// Mapeia a sigla da cidade para o nome completo
		const cityNames = {
			RJ: "Rio de Janeiro",
			SP: "São Paulo",
		};
		const cityName = cityNames[city] || city;

		// Atualiza a mensagem de sucesso
		const successMessage = document.getElementById(
			"city-success-message"
		);
		if (successMessage) {
			successMessage.textContent = `${cityName} selecionado com sucesso!`;
		}

		// Adiciona a classe de sucesso para mostrar a animação
		modal.classList.add("city-modal--success");

		// Fecha o modal após 3 segundos
		setTimeout(() => {
			hideModal();
		}, 2000);
	}

	function openDrawer(drawerId) {
		if (!drawerId) return;

		const drawer = document.getElementById(drawerId);
		if (!drawer) return;

		// Pequeno delay para garantir que o DOM está pronto
		setTimeout(() => {
			// Verifica se o drawer tem o método show (custom element)
			if (drawer && typeof drawer.show === "function") {
				drawer.show();
			} else {
				// Fallback: tenta clicar no botão que controla o drawer
				const controlButton = document.querySelector(
					`[aria-controls="${drawerId}"]`
				);
				if (controlButton) {
					// Cria um novo evento de clique para simular o clique original
					const clickEvent = new MouseEvent("click", {
						bubbles: true,
						cancelable: true,
						view: window,
					});
					controlButton.dispatchEvent(clickEvent);
				}
			}
		}, 150);
	}

	// Verifica se um botão abre um quick-buy-drawer
	function isQuickBuyButton(button) {
		if (!button) return false;

		// Verifica se tem data-city-guard-add
		if (button.hasAttribute("data-city-guard-add")) {
			return true;
		}

		// Verifica se tem aria-controls apontando para um quick-buy-drawer
		const drawerId = button.getAttribute("aria-controls");
		if (drawerId) {
			const drawer = document.getElementById(drawerId);
			if (drawer && drawer.tagName === "QUICK-BUY-DRAWER") {
				return true;
			}
		}

		return false;
	}

	// Detecta quando o modal é aberto externamente (pelo header)
	// Observa mudanças no modal para detectar quando é aberto sem passar pela função showModal()
	const modal = document.getElementById("city-modal");
	if (modal) {
		let wasActive = modal.classList.contains("city-modal--active");

		const observer = new MutationObserver(() => {
			const isActive =
				modal.classList.contains("city-modal--active");

			// Se o modal foi aberto (mudou de inativo para ativo) e não há drawer pendente
			// E não foi aberto pela função showModal, significa que foi aberto pelo header (onclick inline)
			// Se estava marcado como aberto automaticamente, reseta essa flag pois agora foi aberto pelo header
			if (
				isActive &&
				!wasActive &&
				!pendingDrawerId &&
				!openedByShowModal
			) {
				if (openedAutomaticallyOnProductPage) {
					// Se foi aberto automaticamente antes, mas agora foi aberto pelo header, reseta a flag
					openedAutomaticallyOnProductPage = false;
				}
				openedFromHeader = true;
			}

			wasActive = isActive;
		});

		observer.observe(modal, {
			attributes: true,
			attributeFilter: ["class", "aria-hidden"],
		});
	}

	// INTERCEPTA BOTÕES DE ADD TO CART / QUICK BUY
	document.addEventListener(
		"click",
		(e) => {
			// Procura pelo botão clicado (pode ser o próprio elemento ou um ancestral)
			let btn = e.target.closest("button");

			// Se não encontrou um botão, tenta encontrar por outros seletores
			if (!btn) {
				btn = e.target.closest("[aria-controls]");
			}
			if (!btn) {
				btn = e.target.closest("[data-city-guard-add]");
			}
			// Também verifica se o próprio elemento é um botão ou tem os atributos
			if (
				!btn &&
				(e.target.tagName === "BUTTON" ||
					e.target.hasAttribute("aria-controls") ||
					e.target.hasAttribute("data-city-guard-add"))
			) {
				btn = e.target;
			}

			if (!btn || !isQuickBuyButton(btn)) return;

			const city = getCity();

			// Se não tem cidade selecionada, intercepta o clique
			if (!city) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				// Armazena o ID do drawer que deve ser aberto
				const drawerId = btn.getAttribute("aria-controls");
				if (drawerId) {
					pendingDrawerId = drawerId;
				} else {
					// Tenta encontrar o drawer de outra forma
					// Primeiro, procura no parent do botão (product-card)
					const parentCard = btn.closest("product-card");
					if (parentCard) {
						const drawer =
							parentCard.querySelector(
								"quick-buy-drawer"
							);
						if (drawer && drawer.id) {
							pendingDrawerId = drawer.id;
						}
					}

					// Se não encontrou, tenta no form
					if (!pendingDrawerId) {
						const form = btn.closest("form");
						if (form) {
							const drawer =
								form.querySelector(
									"quick-buy-drawer"
								);
							if (drawer && drawer.id) {
								pendingDrawerId = drawer.id;
							}
						}
					}

					// Se ainda não encontrou, procura próximo ao botão
					if (!pendingDrawerId) {
						const container =
							btn.closest(
								".product-card__quick-buy"
							) ||
							btn.closest(".button-container") ||
							btn.parentElement;
						if (container) {
							const drawer =
								container.querySelector(
									"quick-buy-drawer"
								);
							if (drawer && drawer.id) {
								pendingDrawerId = drawer.id;
							}
						}
					}
				}

				// Garante que não foi aberto pelo header quando é pelo botão de adicionar
				openedFromHeader = false;
				showModal();
				return false;
			}

			// Se já tem cidade, permite o fluxo normal
		},
		true
	); // Usa capture phase para interceptar antes de outros handlers

	// Função auxiliar para verificar se estamos na página de produto
	function isProductPage() {
		return (
			document.querySelector(".product-info") !== null ||
			document.querySelector(".shopify-section--main-product") !==
				null ||
			window.location.pathname.includes("/products/")
		);
	}

	// Botões do modal - seleção de cidade
	document.addEventListener("click", (e) => {
		// Botão de seleção de cidade (RJ ou SP)
		if (
			e.target.matches("[data-city-select]") ||
			e.target.closest("[data-city-select]")
		) {
			const button = e.target.matches("[data-city-select]")
				? e.target
				: e.target.closest("[data-city-select]");
			const city = button.getAttribute("data-city-select");

			if (city) {
				setCity(city);
				// Atualiza o estado visual dos botões
				updateSelectedCityButton();

				// Mostra a mensagem de sucesso
				showSuccessMessage(city);

				// Se havia um drawer pendente, abre agora (fluxo do botão "Adicionar ao carrinho")
				if (pendingDrawerId) {
					// Aguarda o modal fechar (3 segundos) antes de abrir o drawer
					setTimeout(() => {
						openDrawer(pendingDrawerId);
						pendingDrawerId = null;
					}, 2000);
				} else if (
					openedFromHeader &&
					!openedAutomaticallyOnProductPage
				) {
					// Se foi aberto pelo header E não foi aberto automaticamente na página de produto, faz refresh da página
					//window.location.reload();
					return;
				} else {
					// Dispara um evento customizado para notificar os scripts sobre a mudança de cidade
					// Os scripts (como quickbuy-region-warning.js) escutam esse evento e atualizam os elementos automaticamente
					// Aguarda o modal fechar antes de disparar o evento
					setTimeout(() => {
						window.dispatchEvent(
							new CustomEvent("city:changed", {
								detail: { city },
							})
						);
					}, 3100);
				}

				// Reseta as flags
				openedFromHeader = false;
				openedAutomaticallyOnProductPage = false;
			}
		}

		// Botão "Agora não" - apenas fecha o modal
		if (
			e.target.matches("[data-city-skip]") ||
			e.target.closest("[data-city-skip]")
		) {
			hideModal();
			pendingDrawerId = null; // Limpa o drawer pendente
			openedFromHeader = false; // Reseta a flag
			openedAutomaticallyOnProductPage = false; // Reseta a flag
		}
	});

	// Verifica se deve abrir o modal automaticamente na página de produto
	function checkProductPageModal() {
		if (!isProductPage()) return;

		// Verifica se não há cidade no localStorage
		const city = getCity();
		if (!city) {
			// Marca que o modal será aberto automaticamente na página de produto
			openedAutomaticallyOnProductPage = true;
			// Pequeno delay para garantir que o DOM está pronto
			setTimeout(() => {
				showModal(false);
			}, 300);
		}
	}

	// Executa quando o DOM estiver pronto
	if (document.readyState === "loading") {
		document.addEventListener(
			"DOMContentLoaded",
			checkProductPageModal
		);
	} else {
		// DOM já está pronto
		checkProductPageModal();
	}

	// Atualiza o estado visual dos botões quando o DOM estiver pronto
	if (document.readyState === "loading") {
		document.addEventListener(
			"DOMContentLoaded",
			updateSelectedCityButton
		);
	} else {
		updateSelectedCityButton();
	}
})();
